import {afterNextRender, Component, computed, input, output, signal} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {startWith, switchMap} from 'rxjs';
import {ProductDetails} from '../../../../../api';
import {CreditNoteLineModelForm} from '../credit-note-form/credit-note-form';
import {TextInput} from '../../../../components/text-input/text-input';
import {TextArea} from '../../../../components/text-area/text-area';
import {NumericInput} from '../../../../components/numeric-input/numeric-input';
import {TaxDropdown} from '../tax-dropdown/tax-dropdown';
import {ElciaButton} from '../../../../components/buttons/button/button';
import {InvoiceProductDropdown} from '../invoice-product-dropdown/invoice-product-dropdown';

@Component({
  selector: 'elcia-credit-note-line-form',
  imports: [
    TranslatePipe,
    TextInput,
    TextArea,
    NumericInput,
    TaxDropdown,
    ElciaButton,
    InvoiceProductDropdown,
  ],
  templateUrl: './credit-note-line-form.html',
  styleUrl: './credit-note-line-form.scss',
})
export class CreditNoteLineForm {
  readonly fg = input.required<FormGroup<CreditNoteLineModelForm>>();
  readonly legalEntityId = input.required<number | null>();
  readonly creditNoteDate = input.required<Date | null>();

  protected readonly amountOfLine = new FormControl({value: 0, disabled: true});
  readonly onRemove = output();

  protected readonly descriptionVisible = signal(false);

  constructor() {
    toObservable(this.fg).pipe(
      switchMap(fg => fg.valueChanges.pipe(startWith(fg.getRawValue()))),
      takeUntilDestroyed(),
    ).subscribe(value => {
      const quantity = value.quantity ?? 0;
      const unitPrice = value.unitPrice ?? 0;
      this.amountOfLine.setValue(quantity * unitPrice);
    });

    afterNextRender(() => {
      if (this.fg().controls.description.value) this.descriptionVisible.set(true);
    });
  }

  protected toggleDescription(): void {
    this.descriptionVisible.update(visible => !visible);
  }

  // Selecting a product must not overwrite the manually entered label/price.
  protected onProductSelected(_product: ProductDetails | null): void {
  }

  protected remove(): void {
    this.onRemove.emit();
  }
}
